import { Tag } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  position: absolute;
  bottom: 0;
  margin-bottom: 8px;
  width: 100%;
`;

export const StyledTag = styled(Tag)`
  background-color: ${({ theme }) => theme.colors.purple3};
  border: none;
  padding: 4px 8px;
`;
